import { Injectable } from '@angular/core';
import { EmployeePositionModel } from 'src/app/core/models/employee-position.model';
import { HttpClient } from '@angular/common/http';
import { BaseService } from 'src/app/core/base/base.service';
import { AuthService } from '../../../../core/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class EmployeePositionService extends BaseService<EmployeePositionModel> {
  defaultSort = 'createdAt';

  constructor(
    public http: HttpClient,
    public authService: AuthService,
  ) {
    super(http, 'employee-position', authService);
  }
}
